<ion-footer class="footer">
  <ion-toolbar>
    <ion-title class="ion-text-center">© 2024 <a href="https://evja.eu">Evja</a> . Tutti i diritti riservati</ion-title>
  </ion-toolbar>
</ion-footer>
